// Monospace live telemetry log with color-coded timestamps.
// entries: [{ ts, kind: 'success'|'analyzing'|'idle'|'warn'|'error', text }]

import { useEffect, useRef } from 'react';

const TONE_FOR = {
  success: 'sage',
  analyzing: 'blue',
  idle: 'slate',
  warn: 'amber',
  error: 'brick',
};

export function TelemetryStream({ entries = [], maxHeight = 220 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [entries.length]);
  return (
    <div className="telemetry" style={{ maxHeight }}>
      <header className="telemetry-header">
        <span className="chip live sm">
          <span className="chip-dot pulse" /> Telemetry stream
        </span>
        <span className="mono small muted">{entries.length} events</span>
      </header>
      <div ref={ref} className="telemetry-body mono">
        {entries.length === 0 ? (
          <div className="telemetry-line">
            <span className="telemetry-ts">[waiting]</span> agent idle
          </div>
        ) : null}
        {entries.map((e, i) => (
          <div key={i} className={`telemetry-line tone-${TONE_FOR[e.kind] || 'slate'}`}>
            <span className="telemetry-ts">[{e.ts}]</span> {e.text}
          </div>
        ))}
      </div>
    </div>
  );
}
